import { vec2 } from "./VectorMath.ts"


export class Rect {
  constructor(
    readonly x: number,
    readonly y: number,
    readonly width: number,
    readonly height: number
  ) { }

  insetBy(d: number): Rect {
    return new Rect(
      this.x + d,
      this.y + d,
      this.width - 2 * d,
      this.height - 2 * d
    )
  }

  horizontalInsetBy(d: number): Rect {
    return new Rect(
      this.x + d,
      this.y,
      this.width - 2 * d,
      this.height
    )
  }

  ;
  *[Symbol.iterator]() {
    yield this.x
    yield this.y
    yield this.width
    yield this.height
  }

  get tuple(): [number, number, number, number] {
    return [this.x, this.y, this.width, this.height]
  }

  get topLeft(): vec2 { return new vec2(this.x, this.y) }
  get topMiddle(): vec2 { return new vec2(this.x + 0.5 * this.width, this.y) }
  get topRight(): vec2 { return new vec2(this.x + this.width, this.y) }
  get middleRight(): vec2 { return new vec2(this.x + this.width, this.y + 0.5 * this.height) }
  get bottomRight(): vec2 { return new vec2(this.x + this.width, this.y + this.height) }
  get bottomMiddle(): vec2 { return new vec2(this.x + 0.5 * this.width, this.y + this.height) }
  get bottomLeft(): vec2 { return new vec2(this.x, this.y + this.height) }
  get middleLeft(): vec2 { return new vec2(this.x, this.y + 0.5 * this.height) }
}
